import React, { FC, useState } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { addLinkQueryParams } from '../../../../../../server/utils/addLinkQueryParams';
import { FaqItem } from '../../../../../../shared/types';

import './index.scss';

interface FaqsProps {
  faqs?: FaqItem[];
}

export const Faqs: FC<FaqsProps> = ({ faqs }) => {
  // First item is expanded by default.
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs?.length) {
    return null;
  }

  const toggle = (index: number) => setOpenIndex((current) => (current === index ? -1 : index));

  return (
    <section className="article-faqs">
      <h2 className="faqs-title">{translate<string>('fiverr_guides.guide.faqs.title')}</h2>

      <ul className="faqs-list">
        {faqs.map(({ question, answer }, index) => {
          const isOpen = openIndex === index;

          return (
            <li key={index} className={`faqs-item ${isOpen ? 'is-open' : ''}`}>
              <button type="button" className="faqs-header" aria-expanded={isOpen} onClick={() => toggle(index)}>
                <h3 className="faqs-question">{question}</h3>
                <span className="faqs-icon" aria-hidden="true" />
              </button>
              {isOpen && (
                <div
                  className="faqs-answer rich-text"
                  dangerouslySetInnerHTML={{ __html: addLinkQueryParams(answer) }}
                />
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default Faqs;
